// @generated by protoc-gen-zod-es v0.0.1 with parameter "target=ts,import_extension=none"
// @generated from file tenki/cloud/identity/v1beta1/identity_service.proto (package tenki.cloud.identity.v1beta1, syntax proto3)
/* eslint-disable */

import { z } from "zod";
import { projectPermissionSchema, workspacePermissionSchema } from "./permissions_zod";
import { flowSchema, loginFlowSchema, recoveryFlowSchema, registrationFlowSchema, settingsFlowSchema, verificationFlowSchema } from "./flow_zod";
import { userSchema } from "./identity_zod";
import { sSHKeySchema } from "./ssh_key_zod";

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetUserPermissionsRequest
 */
export const getUserPermissionsRequestSchema = z.object({
  workspaceId: z.string(),
  projectId: z.string().optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetUserPermissionsResponse
 */
export const getUserPermissionsResponseSchema = z.object({
  workspacePermission: workspacePermissionSchema.optional(),
  projectPermission: projectPermissionSchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.CreateFlowRequest
 */
export const createFlowRequestSchema = z.object({
  flowType: z.string(),
  returnTo: z.string().optional(),
  aal: z.boolean().optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.CreateFlowResponse
 */
export const createFlowResponseSchema = z.object({
  flow: flowSchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.CreateSettingsFlowRequest
 */
export const createSettingsFlowRequestSchema = z.object({
  returnTo: z.string().optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.CreateSettingsFlowResponse
 */
export const createSettingsFlowResponseSchema = z.object({
  flow: settingsFlowSchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetLoginFlowRequest
 */
export const getLoginFlowRequestSchema = z.object({
  flowId: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetLoginFlowResponse
 */
export const getLoginFlowResponseSchema = z.object({
  flow: loginFlowSchema.optional(),
  errors: z.array(z.string()),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetRegistrationFlowRequest
 */
export const getRegistrationFlowRequestSchema = z.object({
  flowId: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetRegistrationFlowResponse
 */
export const getRegistrationFlowResponseSchema = z.object({
  flow: registrationFlowSchema.optional(),
  errors: z.array(z.string()),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetVerificationFlowRequest
 */
export const getVerificationFlowRequestSchema = z.object({
  flowId: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetVerificationFlowResponse
 */
export const getVerificationFlowResponseSchema = z.object({
  flow: verificationFlowSchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetRecoveryFlowRequest
 */
export const getRecoveryFlowRequestSchema = z.object({
  flowId: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetRecoveryFlowResponse
 */
export const getRecoveryFlowResponseSchema = z.object({
  flow: recoveryFlowSchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetSettingsFlowRequest
 */
export const getSettingsFlowRequestSchema = z.object({
  flowId: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetSettingsFlowResponse
 */
export const getSettingsFlowResponseSchema = z.object({
  flow: settingsFlowSchema.optional(),
  user: userSchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.CliLoginRequest
 */
export const cliLoginRequestSchema = z.object({
  email: z.string(),
  password: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.CliLoginResponse
 */
export const cliLoginResponseSchema = z.object({
  token: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.LoginRequest
 */
export const loginRequestSchema = z.object({
  flowId: z.string(),
  email: z.string(),
  password: z.string(),
  csrfToken: z.string(),
  method: z.string(),
  code: z.string().optional(),
  provider: z.string().optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.LoginResponse
 */
export const loginResponseSchema = z.object({
  token: z.string(),
  message: z.string(),
  returnTo: z.string(),
  status: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.LogoutRequest
 */
export const logoutRequestSchema = z.object({
  logoutToken: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.LogoutResponse
 */
export const logoutResponseSchema = z.object({
  status: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.RegistrationRequest
 */
export const registrationRequestSchema = z.object({
  flowId: z.string(),
  email: z.string(),
  password: z.string(),
  csrfToken: z.string(),
  method: z.string(),
  provider: z.string().optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.RegistrationResponse
 */
export const registrationResponseSchema = z.object({
  userId: z.string(),
  token: z.string(),
  status: z.string(),
  returnTo: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.RecoveryRequest
 */
export const recoveryRequestSchema = z.object({
  flowId: z.string(),
  email: z.string().optional(),
  code: z.string().optional(),
  csrfToken: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.RecoveryResponse
 */
export const recoveryResponseSchema = z.object({
  status: z.string(),
  returnTo: z.string(),
  token: z.string(),
  message: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetUserRequest
 */
export const getUserRequestSchema = z.object({
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetUserResponse
 */
export const getUserResponseSchema = z.object({
  user: userSchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.CreateSSHKeyRequest
 */
export const createSSHKeyRequestSchema = z.object({
  name: z.string(),
  publicKey: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.CreateSSHKeyResponse
 */
export const createSSHKeyResponseSchema = z.object({
  sshKeyId: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.DeleteSSHKeyRequest
 */
export const deleteSSHKeyRequestSchema = z.object({
  sshKeyId: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.DeleteSSHKeyResponse
 */
export const deleteSSHKeyResponseSchema = z.object({
  sshKeyId: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetSSHKeyRequest
 */
export const getSSHKeyRequestSchema = z.object({
  sshKeyId: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetSSHKeyResponse
 */
export const getSSHKeyResponseSchema = z.object({
  sshKey: sSHKeySchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.ListSSHKeysRequest
 */
export const listSSHKeysRequestSchema = z.object({
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.ListSSHKeysResponse
 */
export const listSSHKeysResponseSchema = z.object({
  keys: z.array(sSHKeySchema),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.UpdatePersonalInfoRequest
 */
export const updatePersonalInfoRequestSchema = z.object({
  flowId: z.string(),
  csrfToken: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.UpdatePersonalInfoResponse
 */
export const updatePersonalInfoResponseSchema = z.object({
  token: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.UpdatePasswordRequest
 */
export const updatePasswordRequestSchema = z.object({
  flowId: z.string(),
  csrfToken: z.string(),
  password: z.string(),
  confirmPassword: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.UpdatePasswordResponse
 */
export const updatePasswordResponseSchema = z.object({
  token: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.ConnectGithubRequest
 */
export const connectGithubRequestSchema = z.object({
  flowId: z.string(),
  csrfToken: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.ConnectGithubResponse
 */
export const connectGithubResponseSchema = z.object({
  token: z.string(),
  message: z.string(),
  returnTo: z.string(),
  status: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.DisconnectGithubRequest
 */
export const disconnectGithubRequestSchema = z.object({
  flowId: z.string(),
  csrfToken: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.DisconnectGithubResponse
 */
export const disconnectGithubResponseSchema = z.object({
  status: z.string(),
  message: z.string(),
  returnTo: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.VerificationRequest
 */
export const verificationRequestSchema = z.object({
  flowId: z.string(),
  email: z.string(),
  code: z.string(),
  csrfToken: z.string(),
  startOnboarding: z.boolean().optional(),
  resendCode: z.boolean().optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.VerificationResponse
 */
export const verificationResponseSchema = z.object({
  status: z.string(),
  message: z.string(),
  type: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.ToggleTotpRequest
 */
export const toggleTotpRequestSchema = z.object({
  flowId: z.string(),
  csrfToken: z.string(),
  code: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.ToggleTotpResponse
 */
export const toggleTotpResponseSchema = z.object({
  status: z.string(),
  message: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.UpdateAvatarRequest
 */
export const updateAvatarRequestSchema = z.object({
  image: z.instanceof(Uint8Array),
  contentType: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.UpdateAvatarResponse
 */
export const updateAvatarResponseSchema = z.object({
  avatarUrl: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.DeleteAvatarRequest
 */
export const deleteAvatarRequestSchema = z.object({
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.DeleteAvatarResponse
 */
export const deleteAvatarResponseSchema = z.object({
  status: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.NotificationSettings
 */
export const notificationSettingsSchema = z.object({
  enabled: z.boolean().optional(),
  disabledTypes: z.array(z.string()),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetNotificationSettingsRequest
 */
export const getNotificationSettingsRequestSchema = z.object({
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetNotificationSettingsResponse
 */
export const getNotificationSettingsResponseSchema = z.object({
  notificationSettings: notificationSettingsSchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.UpdateNotificationSettingsRequest
 */
export const updateNotificationSettingsRequestSchema = z.object({
  notificationSettings: notificationSettingsSchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.UpdateNotificationSettingsResponse
 */
export const updateNotificationSettingsResponseSchema = z.object({
  notificationSettings: notificationSettingsSchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.CheckSessionRequest
 */
export const checkSessionRequestSchema = z.object({
  jwtOnlyCheck: z.boolean().optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.CheckSessionResponse
 */
export const checkSessionResponseSchema = z.object({
  isValid: z.boolean(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetUserByEmailRequest
 */
export const getUserByEmailRequestSchema = z.object({
  email: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.GetUserByEmailResponse
 */
export const getUserByEmailResponseSchema = z.object({
  user: userSchema.optional(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.ListIdentitiesRequest
 */
export const listIdentitiesRequestSchema = z.object({
  ids: z.array(z.string()),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.ListIdentitiesResponse
 */
export const listIdentitiesResponseSchema = z.object({
  users: z.array(userSchema),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.JoinWaitlistRequest
 */
export const joinWaitlistRequestSchema = z.object({
  email: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.JoinWaitlistResponse
 */
export const joinWaitlistResponseSchema = z.object({
  status: z.string(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.SetAccountChecklistStatusRequest
 */
export const setAccountChecklistStatusRequestSchema = z.object({
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.SetAccountChecklistStatusResponse
 */
export const setAccountChecklistStatusResponseSchema = z.object({
  status: z.string(),
});
